import React from "react";
import { useNavigate } from "react-router-dom";
import Skeleton from "./Skeleton";
import { useLanguage } from "../../context/LanguageContext";
import { pickLocalizedName } from "../../utils/localizedName";
import "./clientTheme.css";
import "./CategoryChips.css";

export default function CategoryChips({ title, categories, loading }) {
  const navigate = useNavigate();
  const { language } = useLanguage();

  if (loading) {
    return (
      <section className="category-chips-section">
        {title && (
          <div className="category-chips-header">
            <h2 className="category-chips-title">{title}</h2>
          </div>
        )}
        <div className="category-chips">
          {Array.from({ length: 10 }).map((_, index) => (
            <div className="category-chip" key={index}>
              <Skeleton className="category-chip-skeleton-image" />
              <Skeleton className="category-chip-skeleton-label" />
            </div>
          ))}
        </div>
      </section>
    );
  }

  if (!categories || categories.length === 0) return null;

  return (
    <section className="category-chips-section">
      {title && (
        <div className="category-chips-header">
          <h2 className="category-chips-title">{title}</h2>
        </div>
      )}
      <div className="category-chips">
      {categories.map((category) => {
        const name = pickLocalizedName(language, category.name, category.nameArabic, category.nameHebrew);
        return (
          <button
            key={category.categoryId}
            type="button"
            className="category-chip"
            onClick={() => navigate(`/products?categoryId=${category.categoryId}`)}
          >
            {category.imageUrl ? (
              <img src={category.imageUrl} alt="" className="category-chip-image" />
            ) : (
              <div className="category-chip-image category-chip-image-placeholder">
                {name.charAt(0)}
              </div>
            )}
            <span className="category-chip-label">{name}</span>
          </button>
        );
      })}
      </div>
    </section>
  );
}
